
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections-list",
      function () {
        return require("private-next-pages/collections-list.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collections-list"])
      });
    }
  